import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS_PAST from '../events/REQUIRED_FIELDS_PAST';

export default function usePastInvitationsForUser(user, options = {}) {
  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          invitations: {
            $where: {
              userId: user.id,
              response: 'Yes'
            }
          },
          $and: REQUIRED_FIELDS_PAST.$and
        }
      }
    },
    pagination: {
        page: options.page || 1,
        pageSize: options.pageSize || 3,
        order: 'createdAt desc',
      }
    });
  }
